<app-toolbar></app-toolbar>
<div class="row"
     style="text-align: right; margin-bottom: -30px;">
  <a routerLink="adicionar">
    <img class="imgAdicionar"
         src="../../../assets/icones/adicionar.svg">
  </a>
</div>

<div *ngFor="let perfil of perfis">
  <h6 class="title-category">{{ perfil | translate }}</h6>
  <div class="row"
       style="justify-content: center;align-items: center;display: flex;">
    <div class="col s12 m12 l12 card-block">
      <div class="row">
        <div class="col cardDiv"
             *ngFor="let usuario of usuariosFiltros(perfil)">
          <div class="card">
            <div class="linha">
              <div class="imgDiv">
                <img class="responsive-img"
                     [src]="usuario.image ? usuario.image.secure_url : 'assets/images/nophoto.png'">
              </div>
              <div>
                <div class="div-dados">
                  <span class="card-title">
                    {{usuario.name}}
                  </span>
                  <br>
                  <span class="titleItalic">
                    {{usuario.email}}
                  </span>
                </div>
                <div class="divBotoes">
                  <a class="botoes"
                     (click)="editar(usuario._id)">
                    <img class="imgIcones"
                         src="../../../assets/icones/editar.svg"
                         [title]="translatePipe.transform('texto_editar')">
                  </a>
                  <a class="botoes"
                     (click)="novasenha(usuario.email)">
                    <img class="imgIcones"
                         src="../../../assets/icones/senha.svg"
                         [title]="translatePipe.transform('texto_nova_senha')">
                  </a>
                  <a class="botoes"
                     (click)="excluir(usuario._id)">
                    <img class="imgIcones"
                         src="../../../assets/icones/excluir.svg"
                         [title]="translatePipe.transform('texto_excluir')">
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>